import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `ControlSemen/filtrarControlSemen`, method: 'POST', body: values, token: token})
}
